jQuery(function($){
    function initHeroVideo() {
      var data_id = '';
      if ($(window).width() <= 740) { 
        data_id = 'm_src';
      } else {
        data_id = 'd_src';
      }
      $('body').find('#hero-video').find('source').each(function(){ 
        $(this).attr('src', $(this).data(data_id));
      });
      setTimeout(function(){
        $('body').find('#hero-video').get(0).load();
        setTimeout(function(){
          $('#hero-video').get(0).play();
          $('#hero_vimeo_video').find('.hvv-loader').hide();
          $('#hero_vimeo_video').find('.video-wrapper').show();
        }, 100);
      }, 250);
      $(window).resize(function() {
        $('body').find('#hero-video').get(0).play();
      });
    }

    function initMiddleVideo() {
      // middle-video
      // $('body').find('#middle-video').find('source').each(function(){ 
      //   $(this).attr('src', $(this).data('src'));
      // });
      // setTimeout(function(){
      //   $('body').find('#middle-video').get(0).load();
      // }, 350);

      window.addEventListener('scroll', function() {
        if ($(window).width() <= 760) {  
          scroll_start = Math.floor($('.middle-video-wrapper').position().top.toFixed(0)) - 400;  
          scroll_finish = Math.floor($('.middle-video-wrapper').position().top.toFixed(0)) + 300;
        } else {
          scroll_start = Math.floor($('.middle-video-wrapper').position().top.toFixed(0)) - 700;  
          scroll_finish = Math.floor($('.middle-video-wrapper').position().top.toFixed(0)) + 900;
        }

        if (pageYOffset >= scroll_start && pageYOffset <= scroll_finish) {
            $('body').find('#middle-video').get(0).play();
        } else {
            $('body').find('#middle-video').get(0).pause();
        }
      });
    }
    function initParallaxVideo(){
        const html = document.documentElement;
        const canvas = document.getElementById("hnpw-canvas");
        const context = canvas.getContext("2d");
        const frameCount = 148;
        var currentFrame = $('body').find('#hnpw-canvas').data('urls').split(';');
        if ($(window).width() <= 760) {  
          const frameCount = 148;
          var currentFrame = $('body').find('#hnpw-canvas').data('urls-mobile').split(';');
        }

        const preloadImages = () => {
          for (let i = 0; i < frameCount; i++) {
            const img = new Image();
            img.src = currentFrame[i];
          }
        };

        const img = new Image()
        img.src = currentFrame[0];
        canvas.width=720;
        canvas.height=1000;
        if ($(window).width() <= 760) {  
          canvas.width=720;
          canvas.height=1000;
        }

        img.onload=function(){
          context.drawImage(img, 0, 0);
        }

        const updateImage = index => {
          img.src = currentFrame[index];
          context.drawImage(img, 0, 0);
        }

        if ($(window).width() <= 960) { 
          $('body').find('.home-page-video').css('height', 1800);
        } else {
          $('body').find('.home-page-video').css('height', 3000);
        }        
        var scroll_start = 0;
        var scroll_finish = 0;
        window.addEventListener('scroll', () => {  
          if ($(window).width() <= 760) {  
            scroll_start = Math.floor($('.home-page-video').position().top.toFixed(0)) - 530;  
            scroll_finish = Math.floor($('.fix_index_image').position().top.toFixed(0)) - 500;
          } else {
            scroll_start = Math.floor($('.home-page-video').position().top.toFixed(0)) - 550;  
            scroll_finish = Math.floor($('.fix_index_image').position().top.toFixed(0)) - 800;
            if ($('body').hasClass('retina-body')) {
              scroll_start = Math.floor($('.home-page-video').position().top.toFixed(0)) - 290; 
            }
          }

          if (pageYOffset >= scroll_start && pageYOffset <= scroll_finish) {
            if ($(window).width() <= 760) {  
              var scroll_val = (pageYOffset - scroll_start) / ((scroll_finish - scroll_start) / 148);
            } else {
              var scroll_val = (pageYOffset - scroll_start) / ((scroll_finish - scroll_start) / 148);
            }
            requestAnimationFrame(() => updateImage(scroll_val.toFixed(0)))
          }
          var pulse_scroll_finish = scroll_finish - 300;
          var pulse_scroll_start = scroll_start + 350;
          if (pageYOffset >= pulse_scroll_start && pageYOffset < pulse_scroll_finish) {
            $('body').find('.hpv-arrow').css('opacity', 1);
          } else if (pageYOffset > pulse_scroll_finish) {
            $('body').find('.hpv-arrow').addClass('hpv-arrow-back');
            $('body').find('.hpv-arrow').css('opacity', 0);
          } else if (pageYOffset < pulse_scroll_start) {
            $('body').find('.hpv-arrow').css('opacity', 0);
            $('body').find('.hpv-arrow').removeClass('hpv-arrow-back');
          } 
        });

        $('body').find('.hpv-arrow').click(function(){
          if ($(this).hasClass('hpv-arrow-back')) {
            $('html,body').animate({
              scrollTop: scroll_start+150
            }, 4000);
          } else {
            $('html,body').animate({
              scrollTop: scroll_finish+150
            }, 4000);
          }     
        });

        preloadImages();
    }

function browserTester(browserString) {
    return navigator.userAgent.toLowerCase().indexOf(browserString) > -1;
}

var time_1 = 10;
var time_2 = 100;
var time_3 = 4000;

if(browserTester('google') || browserTester('bing') || browserTester('gtmetrix') || browserTester('lighthouse')) {
  time_1 = 10;
  time_2 = 100;
  time_3 = 8000;       
}

$(window).load(function() {
  setTimeout(function(){
    initHeroVideo();
  }, time_1);
  setTimeout(function(){
    initMiddleVideo();
  }, time_2);
  setTimeout(function(){
    initParallaxVideo();
  }, time_3);
});
});

$(".rf-video-mute").click(function(){
  // var video_obj = $(this).parent().parent().find("video").get(0);
  if($(this).parent().parent().find("video").prop('muted')) {
    // video_obj.muted = !video_obj.muted;
    $(this).removeClass('rf-video-unmute');
    $(this).parent().parent().find("video").prop('muted', false);
    $(this).parent().parent().find("video").attr('muted', false);
  } else {
    // video_obj.muted;
    $(this).addClass('rf-video-unmute');
    $(this).parent().parent().find("video").prop('muted', true);
    $(this).parent().parent().find("video").attr('muted', true);
  }
});